module.exports = __webpack_public_path__ + "img/whatInReportImage3.4d9b2128.png";